export default __webpack_public_path__ + "static/media/weathehrapp.e891a950.png";